// src/components/ExportExcelButton.js
import React, { useState } from 'react';
import { exportProperty, exportComparison } from '../api';

const ExportExcelButton = ({ propertyId, propertyIds, label = '📊 Download Excel', variant = 'single' }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleExport = async () => {
        setLoading(true);
        setError('');

        try {
            let response;
            
            if (variant === 'single' && propertyId) {
                response = await exportProperty(propertyId);
            } else if (variant === 'comparison' && propertyIds && propertyIds.length > 0) {
                response = await exportComparison(propertyIds);
            } else {
                throw new Error('Invalid export configuration');
            }

            // Create download link
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', response.headers['content-disposition']?.split('filename=')[1] || 'property.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            setError('Failed to export Excel: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <button
                onClick={handleExport}
                disabled={loading}
                className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded flex items-center gap-2 disabled:opacity-50"
            >
                {loading ? (
                    <>
                        <span className="animate-spin">⏳</span>
                        Generating...
                    </>
                ) : (
                    <>
                        📊 {label}
                    </>
                )}
            </button>
            {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
        </div>
    );
};

export default ExportExcelButton;